import { render, staticRenderFns } from "./MyMealView.vue?vue&type=template&id=9edaf8ba&scoped=true"
import script from "./MyMealView.vue?vue&type=script&lang=js"
export * from "./MyMealView.vue?vue&type=script&lang=js"
import style0 from "./MyMealView.vue?vue&type=style&index=0&id=9edaf8ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9edaf8ba",
  null
  
)

export default component.exports